import React from 'react';
import { BrowserRouter } from "react-router-dom";
import Main from './pages/Main';
import { CartWishlistProvider } from './pages/CartWishlistContext';

function App() {
  return (
    <CartWishlistProvider>
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    </CartWishlistProvider>
  );
}

export default App;